<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-calculator'"></top-line>
      <div class="back-button">
        <el-button @click="goBackWithPagination" icon="el-icon-arrow-left">返回</el-button>
      </div>
     <el-card shadow="hover" style=" margin: 20px 20px;">
      <el-descriptions title="资源类型基本信息" :column="2" border :colon="true" >
        <!-- 基本信息 -->
        <el-descriptions-item label="ID">{{ detail.id }}</el-descriptions-item>
        <el-descriptions-item label="资源类型名称">{{ detail.name }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ formatStatus(detail.status) }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detail.remark }}</el-descriptions-item>
        <el-descriptions-item label="父ID">{{ detail.p_id || '–' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDateTime(detail.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ detail.created_by }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDateTime(detail.updated_at) }}</el-descriptions-item>
        <el-descriptions-item label="更新人">{{ detail.updated_by }}</el-descriptions-item>
      </el-descriptions>

      <el-row style="margin-top: 30px; text-align: center;">
        <el-button @click="goBackWithPagination">返回</el-button>
      </el-row>
    </el-card>

  </d2-container>
</template>


<script>
import topLine from "@/components/save-common/topLine.vue";

export default {
  name: 'ComputeTypeDetails',
  components: {
    topLine
  },
  data() {
    return {
      pageTitle: "资源类型详情",
      labelWidth: '120px',
      detail: {}
    }
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      this.fetchDetail(id);
    } else {
      console.error('No id provided');
    }
  },
  methods: {
    async fetchDetail(id) {
      try {
        const response = await this.$axios.get(`/api-30216/api/compute-types/${id}`); 
        this.detail = response.data; // 假设响应直接包含算力类型详情
      } catch (error) {
        console.error('Failed to fetch compute type details', error);
      }
    },
    formatStatus(val) {
      const map = { 0: '有效', 1: '无效'};
      return map[val] || '未知';
    },

    // 格式化日期时间
    formatDateTime(datetime) {
      if (!datetime) return '';
      
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return '';
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    goBackWithPagination() {
      const previousPagePath = '/api/compute-types'; 
      // 获取当前路由中的分页信息
      const { page, pageSize } = this.$route.query;
      this.$router.push({
        path: previousPagePath,
        query: {
          page: page || 1,       // 如果没有page参数，默认为第一页
          pageSize: pageSize || 10, // 如果没有pageSize参数，默认每页显示10条
        }
      });
    },
  }
}
</script>
<style scoped>
.back-button {
  margin-left: 20px;
}

</style>